import { render, staticRenderFns } from "./QuotationStepRisk.vue?vue&type=template&id=0e2d3e8f"
import script from "./QuotationStepRisk.vue?vue&type=script&lang=js"
export * from "./QuotationStepRisk.vue?vue&type=script&lang=js"
import style0 from "./QuotationStepRisk.vue?vue&type=style&index=0&id=0e2d3e8f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports